import { BaseModel } from "sjs-base-model";

export default class UserPermissionModel extends BaseModel {
    public readonly permissions: string[] = [];

    constructor(data: Partial<UserPermissionModel>) {
        super();

        this.update(data);
    }
}
